/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Button, Input, Form } from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';

import IntlMessages from 'util/IntlMessages';
import InfoView from 'components/common/InfoView';
import { userSignIn, verifyRecapture } from '../redux/actions/Auth';
import logo from '../assets/images/kitegateway_icon_light.png';
import background from '../assets/images/bg/8.jpg';
import { Environments } from '../constants/System';
import Verify2FA from './Verify2FA';

const SignIn = (props) => {
  const dispatch = useDispatch();
  const token = useSelector(({ auth }) => auth.token);
  const { verifiedRecaptcha } = useSelector(({ auth }) => auth);
  const [showReCapture, setShowReCapture] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');
  const authUser = useSelector(({ auth }) => auth.authUser);
  const [showVerify2FAModal, setShowVerify2FAModal] = useState(false);
  const [readOnly, setReadOnly] = useState(true);

  const { history } = props;

  const onVerifedRecaptcha = (value) => {
    dispatch(verifyRecapture(value));
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const onFinish = (values) => {
    dispatch(userSignIn(values));
    // Reset token after 2 minutes, since thats when
    // the token expires
    setTimeout(() => {
      setCaptchaToken('');
    }, 120000);
  };

  const environment = process.env.REACT_APP_ENVIRONMENT;

  useEffect(() => {
    if (verifiedRecaptcha && verifiedRecaptcha.status) {
      setCaptchaToken('token');
    }
    if (token !== null && authUser) {
      if (authUser.is_2fa_enabled === true) {
        setShowVerify2FAModal(true);
      } else {
        history.push('/dashboard');
      }
    } else {
      if (environment === Environments.PRODUCTION) {
        setShowReCapture(true);
      }
      history.push('/signin');
    }
  }, [authUser, history, verifiedRecaptcha, environment, token]);

  const handleCancelVerify2fa = () => {
    setShowVerify2FAModal(false);
  };

  const enablePasswordField = () => {
    setTimeout(() => setReadOnly(false), 300);
  };

  const disableAutoFill = () => {
    setReadOnly(true);
    enablePasswordField();
  };

  const passwordChanged = (e) => {
    if (e.target.value.trim().length === 0) {
      disableAutoFill();
    }
  };

  return (
    <div className="gx-app-login-wrap" style={{ backgroundImage: `url(${background})` }} >
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg" />
            <div className="gx-app-logo-wid">
              <h1>
                <IntlMessages id="app.userAuth.signIn" />
              </h1>
              <h1>
                <IntlMessages id="app.userAuth.bySigning" />
              </h1>
              <p>
                <IntlMessages id="app.userAuth.getAccount" />
              </p>
            </div>
            <div className="gx-app-logo">
              <img
                src={logo}
                alt="Kitegateway"
                title="Kitegateway"
              />
            </div>
          </div>
          <div className="gx-app-login-content">
            <Form
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
              autoComplete="off"
            >
              <Form.Item
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                ]}
                name="email"
              >
                <Input placeholder="Email" autoComplete="username" />
              </Form.Item>
              <Form.Item
                rules={[
                  { required: true, message: 'Please input your Password!' },
                ]}
                name="password"
              >
                <Input onChange={passwordChanged} onContextMenu={(e) => e.preventDefault()} onClick={disableAutoFill} readOnly={readOnly} onFocus={enablePasswordField} type="password" placeholder="Password" autoComplete="off" />
              </Form.Item>
              <Form.Item>
                <Link
                  className="gx-login-form-forgot"
                  to="/forgot-password"
                >
                  Forgot password
                </Link>
              </Form.Item>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
                onChange={onVerifedRecaptcha}
              />
              <br />
              <Form.Item>
                <Button
                  type="primary"
                  className={`gx-mb-0 ${captchaToken || !showReCapture ? 'enabled' : 'disabled'}`}
                  htmlType={captchaToken || !showReCapture ? 'submit' : 'button'}
                >
                  <IntlMessages id="app.userAuth.signIn" />
                </Button>
                {/* <span>
                  <IntlMessages id="app.userAuth.or" />
                </span> */}
                {/* {' '}
                <Link to="/signup" className="gx-text-paylense-blue">
                  <IntlMessages id="app.userAuth.signUp" />
                </Link> */}
              </Form.Item>
            </Form>
          </div>
          <InfoView />
          <Verify2FA visible={showVerify2FAModal} handleCancel={handleCancelVerify2fa} />
        </div>
      </div>
    </div>
  );
};

SignIn.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default SignIn;
